import { SmartBuildingApiModels } from '@smartbuilding/sdk';
import NoiseLevel = SmartBuildingApiModels.NoiseLevel;

export function isNoiseLevelMeasurementType(measurement: any): measurement is NoiseLevel {
    return measurement.averageValue !== undefined;
}
